<template>
 <div class="reservation-container"> 
    <!-- 表单内容 -->
    <div class="form-content">
        <!-- 预约单信息 -->
        <div class="form-section">
            <h3 class="section-title">预约单信息</h3>
            <van-field 
                v-model="contact" 
                placeholder="请输入联系人" 
                label="联系人" 
                required
                class="form-field"
            />
            <van-field 
                v-model="tel" 
                placeholder="请输入联系电话" 
                label="联系电话" 
                type="tel" 
                required
                class="form-field"
            />
            
            <van-cell 
                is-link 
                title="省份" 
                :value="province" 
                @click="show = true"
                class="form-cell left-align"
            />
            <van-action-sheet
                v-model="show"
                :actions="provinces"
                cancel-text="取消"
                @cancel="onCancelProvince"
                @select="onSelectProvince"
            />
            
            <van-cell 
                is-link 
                title="城市" 
                :value="city"  
                @click="show2 = true"
                class="form-cell left-align"
            />
            <van-action-sheet
                v-model="show2"
                :actions="cities"
                cancel-text="取消"
                @cancel="onCancelCity"
                @select="onSelectCity"
            />
            
            <van-field 
                v-model="address" 
                placeholder="请输入详细地址" 
                label="上门地址" 
                required
                class="form-field"
            />		
            
            <van-field 
                v-model="sn" 
                placeholder="请输入打印机序列号" 
                label="序列号SN" 
                maxlength="20"
                :error-message="errMsg" 
                @blur="getsn" 
                required
                class="form-field"
            />
            
            <van-field 
                v-model="sninfo[0].erpname"  
                label="打印机名称" 
                readonly
                class="form-field"
            />
            
            <van-field 
                v-model="sninfo[0].scan_date" 
                label="出厂日期"  
                readonly
                class="form-field"
            />
            
            <van-field 
                v-model="buydate" 
                placeholder="请输入购买日期" 
                label="购买日期" 
                type="date"
                class="form-field"
            />		  
            
            <van-field 
                v-model="descr" 
                placeholder="请描述故障现象" 
                label="故障现象" 
                rows="3"
                type="textarea" 
                autosize 
                required
                class="form-field"
            />
            
            <!-- 服务方式 -->
            <div class="form-group">
                <div class="form-label">服务方式</div>
                <van-radio-group v-model="radio" class="radio-group">
                    <van-radio name="58" class="radio-item">上门服务</van-radio>
                    <van-radio name="121" class="radio-item">送修服务</van-radio>
                </van-radio-group>
            </div>
            <div>具体是以服务站联系后协商为准</div>
        </div>

        <!-- 服务站信息 -->
        <div class="form-section">
            <h3 class="section-title">服务站信息</h3>
            
            <van-cell 
                is-link 
                title="服务站" 
                :value="asp" 
                @click="showAsp = true"
                class="form-cell left-align"
            />
            <van-action-sheet
                v-model="showAsp"
                :actions="aspList"
                cancel-text="取消"
                @cancel="onCancelAsp"
                @select="onSelectAsp"
            />
            
            <van-field 
                v-model="telAsp" 
                label="服务站电话"  
                readonly
                class="form-field"
            />
            
            <van-field 
                v-model="expectDate"  
                label="期望日期" 
                type="date"
                class="form-field"
            />
            
            <!-- 期望时间 -->
            <div class="form-group">
                <div class="form-label">期望时间</div>
                <van-radio-group v-model="radio2" class="radio-group">
                    <van-radio name="9:00:00.000" class="radio-item">上午9点以后</van-radio>
                    <van-radio name="14:00:00.000" class="radio-item">下午2点以后</van-radio>
                </van-radio-group>
            </div>
            
            <van-field 
                v-model="remark" 
                placeholder="输入您的预约留言要求" 
                label="预约留言" 
                rows="2"
                type="textarea" 
                autosize
                class="form-field"
            />	
        </div>

        <!-- 确认信息 -->
        <div class="confirm-section">
            <van-checkbox v-model="checked" shape="square" class="confirm-checkbox">
                请仔细核对以上预约信息后，提交预约确认。如有任何变化，请及时撤销或者更新您的预约信息。
            </van-checkbox>
        </div>

        <!-- 提交按钮 -->
        <div class="action-section">
            <van-button 
                type="primary" 
                size="large" 
                class="submit-btn" 
                :disabled="disabled" 
                @click="submit"
            >
                提交预约
            </van-button>
        </div>
    </div>
 </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { Dialog } from 'vant';
import QS from 'qs'
export default {
  name: 'NEWSR', 
  data(){
  	return{	
        checked:true,
        remark:'',
        expectDate: "",
        telAsp:"",
        errMsg:"",
        disabled:true,
        showCal:false,
        showAsp:false,
        radio:"58",
        radio2:"14:00:00.000",
        show:false,
        show2:false,
        contact:"",
        tel:"",
        address:"",
        model:"",
        sn:"",
        descr:"",
        asp:"请选择服务站",
        province: '请选择省份',
        provinces:[],
        city:'请选择城市',
        cityid:'',
        cities:[],
        aspList:[],		
        svcTime:[],
        svcMode:"",
        expectTime:'',
        showPicker: false,	
        staid:'',
        reserve: require("@/assets/newsr.png"),
        sninfo:[
            {
                erpname:"",
                scan_date:""
            }
        ],
        provinceid:'',
        buydate:''
  	}
  },  
  created(){
      if (this.$root.common.isLogin =="0") {
          this.$router.push({ path:'/'  })		
      }
  },
  mounted(){
    document.title ='预约服务';
    this.getProvinces();
    this.expectDate = this.getDay(1);	
    this.buydate = this.getDay(-90);
  },
  methods:{		
    getDay(day) {　　
        var today = new Date();　　
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
        today.setTime(targetday_milliseconds); //注意，这行是关键代码		                　　
        var tYear = today.getFullYear();　　
        var tMonth = today.getMonth();　　
        var tDate = today.getDate();　　
        tMonth = this.doHandleMonth(tMonth + 1);　　
        tDate = this.doHandleMonth(tDate);　　
        return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {　　
        var m = month;　　
        if (month.toString().length == 1) {　　
            m = "0" + month;　　
        }　　
        return m;
    },
    getProvinces(){		
        var that = this
        var myUrl = that.global.BASE_URL_T3 +  '/api/pdsm/getPdsmprovinces'
        Vue.axios.get(myUrl)
        .then(function (response) {
            var totalrows = response.data.Data.length;
            for(var i = 0; i < totalrows; i++) {
                that.provinces.push({
                    name:response.data.Data[i].areacaption,
                    submame:response.data.Data[i].areaid
                })
            }		 
        })
        .catch(function (error) {
            console.log(error);
        }) 		
    },	
    getCities(){
        var that = this
        var myUrl = that.global.BASE_URL_T3 + '/api/pdsm/getPdsmcities?parentid=' + that.provinceid
        Vue.axios.get(myUrl)
        .then(function (response) {
            var totalrows = response.data.Data.length;
            for(var i = 0; i < totalrows; i++) {
                that.cities.push({
                    name:response.data.Data[i].areacaption,
                    submame:response.data.Data[i].areaid
                })
            }		 
        })
        .catch(function (error) {
            console.log(error);
        }) 		
    },	
    getAsp(province){	
        //get asp list
        var that = this
        Vue.axios.get( that.global.BASE_URL_T3 +  '/api/web/getaspbykeyword?keyword=' + province)
        .then(function (response) {
            that.aspList = response.data.Data;
            console.log(that.aspList)
        })
        .catch(function (error) {
            console.log(error);
        }) 
    },
    onSelectProvince(item){
        this.asp = "请选择服务站";
        this.show = false;
        console.log(item.name)
        this.province = item.name;			
        this.getAsp(this.province);
        this.provinceid = item.submame; 
        this.telAsp = "";
        this.disabled = true;			
        this.getCities();
    },
    onCancelProvince(){
        this.show = false;
    },
    onSelectAsp(item){
        this.showAsp = false;
        this.asp = item.name;
        this.telAsp = item.tel;
        this.staid = item.id;
        this.showCal = true;
        this.disabled = false;
    },
    onCancelAsp(){
        this.showAsp = false;
    },
    checkInput(){
        var result = Boolean;
        result = true;
        if (this.contact == '') result = false;
        if (this.tel == '') result = false;
        if (this.provinceid == '') result = false;
        if (this.cityid == '') result = false;
        if (this.staid == '') result = false;
        if (this.address == '') result = false;
        if (this.descr == '') result = false;
        if (this.sn == '') result = false;
        
        return result;
    },
    submit(){
        let that = this
        console.log(that.checkInput())
        if (that.checkInput()){
            Dialog.confirm({
            message: '确认提交预约单？'
        }).then(() => {
            // on confirm		
            var access_token = localStorage['access_token'];	
                    
            var data = QS.stringify({
                token:'',
                ordtype:that.radio,
                Province:that.provinceid,
                City:that.cityid,
                Staid:that.staid,
                Appdate:that.expectDate,
                Apptime:that.radio2,
                appname:that.contact,
                apptel:that.tel,
                appplace:that.address,
                serilcode:that.sn,
                memo1: that.descr,
                memo2:that.remark,
                buydate:that.buydate,
                source:'公众号'				
            });					 
                
            var postUrl = that.global.BASE_URL_T3 + '/api/pdsm/newapporders';			  
            var config = {
                method: 'post',
                url: postUrl,	
                async:false,	
                headers: { 
                'Authorization': access_token, 
                'Content-Type': 'application/x-www-form-urlencoded'
                },
                data : data
            };
            
            Vue.axios(config)
            .then(function (response) {
                console.log("XXX" + response.data);
                
                if (response.data.Status == '0') {
                    that.disabled = true;				
                    Dialog.alert({ message: '预约单已经提交请保持电话畅通耐心等待。' });
                    that.$router.push({ path:'/reserve'  })				
                } else {
                    Dialog.alert({
                        message: '提交订单失败，请稍后重试。'
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });		
            
        }).catch(() => {
            // on cancel
        });
        } else {
            Dialog.alert({
                message: '请检查联系人，电话，地址，序列号，故障现象，省市、服务站是否已经输入。'
            })
        }
    },
    getsn(){
        var that = this;
        var myUrl = that.global.BASE_URL_T3 + '/api/sn2/getSN?sn=' + that.sn;
        if ((that.sn.length == 20) && (that.sn.length > 0)) {
            Vue.axios.get(myUrl)
            .then(function (response) {
                if (response.data.Status == 0) {
                    that.sninfo = response.data.Data;
                    console.log(that.sninfo)
                    that.errMsg ="";
                } else {
                    that.errMsg = "没有发现出厂信息，请确认是否填写正确。"
                    that.sninfo = [{
                        'erpname':"",
                        'scan_date':""
                    }];
                }
            })
            .catch(function (error) {
                console.log(error);
            }) 
        } else {
            that.errMsg ="请输入20位产品序列号。";
        }
    },		
    onCancelCity(){
        this.show2 = false;
    },
    onSelectCity(item){			
        this.show2 = false;
        this.city = item.name;
        this.cityid = item.submame; 
    }		
  }
}
</script>

<style scoped>
.reservation-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 80px;
}

.form-content {
    padding: 16px;
}

.form-section {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    text-align: left;
}

.form-field {
    padding: 12px 0;
    margin: 0;
}

.form-field:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
}

.form-cell {
    padding: 12px 0;
    margin: 0;
    border-bottom: 1px solid #f5f5f5;
}

.left-align :deep(.van-cell__title) {
    text-align: left;
    flex: none;
    width: 80px;
}

.left-align :deep(.van-cell__value) {
    text-align: left;
    flex: 1;
    color: #323233;
}

.left-align :deep(.van-cell__value--alone) {
    color: #969799;
}

.form-group {
    padding: 16px 0;
    border-bottom: 1px solid #f5f5f5;
}

.form-label {
    font-size: 14px;
    color: #323233;
    font-weight: 500;
    margin-bottom: 12px;
    text-align: left;
}

.radio-group {
    display: flex;
    gap: 20px;
}

.radio-item {
    flex: 1;
}

.confirm-section {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
}

.confirm-checkbox {
    font-size: 13px;
    line-height: 1.5;
    color: #646566;
    text-align: left;
}

.action-section {
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}

.submit-btn {
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
}

.submit-btn:disabled {
    background-color: #c8c9cc;
    border-color: #c8c9cc;
}

/* 响应式设计 */
@media (max-width: 360px) {
    .form-content {
        padding: 12px;
    }
    
    .form-section {
        padding: 16px;
    }
}

/* 自定义 van-field 样式 */
:deep(.van-field__label) {
    color: #323233;
    font-weight: 500;
    text-align: left;
    width: 80px;
}

:deep(.van-field__control) {
    color: #323233;
    text-align: left;
}

:deep(.van-cell__value) {
    color: #969799;
}

:deep(.van-cell__value--alone) {
    color: #323233;
}
</style>